import type { LevelJson } from "./schema";

export const OFFICIAL_LEVELS = [
  {
    id: "level-001",
    order: 1,
    width: 5,
    height: 1,
    fillRequired: false,
    teachingGoal: "建立数值等于路径长度的基础认知。",
    nodes: [
      { color: "blue", role: "origin", x: 0, y: 0, targetLength: 5 },
      { color: "blue", role: "target", x: 4, y: 0 }
    ],
    solution: {
      blue: [
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0],
        [4, 0]
      ]
    }
  },
  {
    id: "level-002",
    order: 2,
    width: 3,
    height: 3,
    fillRequired: false,
    teachingGoal: "强迫玩家绕弯消耗步数，同时保持无障碍唯一解。",
    nodes: [
      { color: "blue", role: "origin", x: 0, y: 0, targetLength: 4 },
      { color: "blue", role: "target", x: 1, y: 0 }
    ],
    solution: {
      blue: [
        [0, 0],
        [0, 1],
        [1, 1],
        [1, 0]
      ]
    }
  },
  {
    id: "level-003",
    order: 3,
    width: 3,
    height: 3,
    fillRequired: false,
    teachingGoal: "引入两条线的互斥占格，学习外圈礼让。",
    nodes: [
      { color: "red", role: "origin", x: 0, y: 0, targetLength: 3 },
      { color: "red", role: "target", x: 2, y: 0 },
      { color: "blue", role: "origin", x: 0, y: 1, targetLength: 4 },
      { color: "blue", role: "target", x: 1, y: 1 }
    ],
    solution: {
      red: [
        [0, 0],
        [1, 0],
        [2, 0]
      ],
      blue: [
        [0, 1],
        [0, 2],
        [1, 2],
        [1, 1]
      ]
    }
  },
  {
    id: "level-004",
    order: 4,
    width: 4,
    height: 4,
    fillRequired: false,
    teachingGoal: "引入更长路径与边界死角，要求玩家主动踩角落消耗步数。",
    nodes: [
      { color: "red", role: "origin", x: 0, y: 0, targetLength: 6 },
      { color: "red", role: "target", x: 1, y: 0 },
      { color: "blue", role: "origin", x: 2, y: 0, targetLength: 8 },
      { color: "blue", role: "target", x: 3, y: 0 }
    ],
    solution: {
      red: [
        [0, 0],
        [0, 1],
        [0, 2],
        [1, 2],
        [1, 1],
        [1, 0]
      ],
      blue: [
        [2, 0],
        [2, 1],
        [2, 2],
        [2, 3],
        [3, 3],
        [3, 2],
        [3, 1],
        [3, 0]
      ]
    }
  },
  {
    id: "level-005",
    order: 5,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "首次开启 100% 填满，三色数字和等于全部格数。",
    nodes: [
      { color: "red", role: "origin", x: 0, y: 0, targetLength: 6 },
      { color: "red", role: "target", x: 2, y: 1 },
      { color: "yellow", role: "origin", x: 0, y: 1, targetLength: 5 },
      { color: "yellow", role: "target", x: 0, y: 3 },
      { color: "blue", role: "origin", x: 2, y: 2, targetLength: 5 },
      { color: "blue", role: "target", x: 1, y: 3 }
    ],
    solution: {
      red: [
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0],
        [3, 1],
        [2, 1]
      ],
      yellow: [
        [0, 1],
        [1, 1],
        [1, 2],
        [0, 2],
        [0, 3]
      ],
      blue: [
        [2, 2],
        [3, 2],
        [3, 3],
        [2, 3],
        [1, 3]
      ]
    }
  },
  {
    id: "level-006",
    order: 6,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "首次引入障碍格，路径沿唯一走廊前进。",
    obstacles: [
      [2, 0],
      [3, 0],
      [0, 1],
      [3, 1],
      [0, 2],
      [1, 2],
      [3, 2],
      [0, 3],
      [1, 3],
      [2, 3],
      [3, 3]
    ],
    nodes: [
      { color: "blue", role: "origin", x: 0, y: 0, targetLength: 5 },
      { color: "blue", role: "target", x: 2, y: 2 }
    ],
    solution: {
      blue: [
        [0, 0],
        [1, 0],
        [1, 1],
        [2, 1],
        [2, 2]
      ]
    }
  },
  {
    id: "level-007",
    order: 7,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "障碍分隔两条线，学习在狭窄走廊中互不干扰。",
    obstacles: [
      [1, 0],
      [2, 0],
      [1, 1],
      [2, 1],
      [0, 3],
      [1, 3],
      [2, 3],
      [3, 3]
    ],
    nodes: [
      { color: "red", role: "origin", x: 0, y: 0, targetLength: 4 },
      { color: "red", role: "target", x: 1, y: 2 },
      { color: "blue", role: "origin", x: 3, y: 0, targetLength: 4 },
      { color: "blue", role: "target", x: 2, y: 2 }
    ],
    solution: {
      red: [
        [0, 0],
        [0, 1],
        [0, 2],
        [1, 2]
      ],
      blue: [
        [3, 0],
        [3, 1],
        [3, 2],
        [2, 2]
      ]
    }
  },
  {
    id: "level-008",
    order: 8,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "在 5x5 盘面中组合三条短走廊，扩大空间感。",
    obstacles: [
      [4, 0],
      [4, 1],
      [2, 2],
      [4, 2],
      [0, 3],
      [2, 3],
      [4, 3],
      [0, 4],
      [4, 4]
    ],
    nodes: [
      { color: "red", role: "origin", x: 0, y: 0, targetLength: 6 },
      { color: "red", role: "target", x: 0, y: 1 },
      { color: "yellow", role: "origin", x: 3, y: 0, targetLength: 5 },
      { color: "yellow", role: "target", x: 3, y: 4 },
      { color: "blue", role: "origin", x: 0, y: 2, targetLength: 5 },
      { color: "blue", role: "target", x: 2, y: 4 }
    ],
    solution: {
      red: [
        [0, 0],
        [1, 0],
        [2, 0],
        [2, 1],
        [1, 1],
        [0, 1]
      ],
      yellow: [
        [3, 0],
        [3, 1],
        [3, 2],
        [3, 3],
        [3, 4]
      ],
      blue: [
        [0, 2],
        [1, 2],
        [1, 3],
        [1, 4],
        [2, 4]
      ]
    }
  },
  {
    id: "level-009",
    order: 9,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "增加四条颜色，训练分区与剩余空间判断。",
    obstacles: [
      [4, 0],
      [2, 1],
      [4, 1],
      [2, 2],
      [4, 2],
      [0, 3],
      [2, 3],
      [4, 3],
      [0, 4],
      [1, 4],
      [2, 4]
    ],
    nodes: [
      { color: "red", role: "origin", x: 0, y: 0, targetLength: 4 },
      { color: "red", role: "target", x: 0, y: 1 },
      { color: "yellow", role: "origin", x: 2, y: 0, targetLength: 4 },
      { color: "yellow", role: "target", x: 3, y: 2 },
      { color: "blue", role: "origin", x: 0, y: 2, targetLength: 3 },
      { color: "blue", role: "target", x: 1, y: 3 },
      { color: "green", role: "origin", x: 3, y: 3, targetLength: 3 },
      { color: "green", role: "target", x: 4, y: 4 }
    ],
    solution: {
      red: [
        [0, 0],
        [1, 0],
        [1, 1],
        [0, 1]
      ],
      yellow: [
        [2, 0],
        [3, 0],
        [3, 1],
        [3, 2]
      ],
      blue: [
        [0, 2],
        [1, 2],
        [1, 3]
      ],
      green: [
        [3, 3],
        [3, 4],
        [4, 4]
      ]
    }
  },
  {
    id: "level-010",
    order: 10,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "首个 6x6 验证关，使用长短线混合和障碍走廊。",
    obstacles: [
      [2, 0],
      [5, 0],
      [2, 1],
      [5, 1],
      [1, 2],
      [2, 2],
      [4, 2],
      [5, 2],
      [0, 3],
      [2, 3],
      [5, 3],
      [0, 4],
      [5, 4],
      [5, 5]
    ],
    nodes: [
      { color: "red", role: "origin", x: 0, y: 0, targetLength: 5 },
      { color: "red", role: "target", x: 0, y: 2 },
      { color: "yellow", role: "origin", x: 3, y: 0, targetLength: 5 },
      { color: "yellow", role: "target", x: 3, y: 2 },
      { color: "blue", role: "origin", x: 1, y: 3, targetLength: 4 },
      { color: "blue", role: "target", x: 0, y: 5 },
      { color: "green", role: "origin", x: 3, y: 3, targetLength: 4 },
      { color: "green", role: "target", x: 4, y: 5 },
      { color: "purple", role: "origin", x: 3, y: 5, targetLength: 4 },
      { color: "purple", role: "target", x: 2, y: 5 }
    ],
    solution: {
      red: [
        [0, 0],
        [1, 0],
        [1, 1],
        [0, 1],
        [0, 2]
      ],
      yellow: [
        [3, 0],
        [4, 0],
        [4, 1],
        [3, 1],
        [3, 2]
      ],
      blue: [
        [1, 3],
        [1, 4],
        [1, 5],
        [0, 5]
      ],
      green: [
        [3, 3],
        [4, 3],
        [4, 4],
        [4, 5]
      ],
      purple: [
        [3, 5],
        [3, 4],
        [2, 4],
        [2, 5]
      ]
    }
  },

  {
    id: "level-011",
    order: 11,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "4x4 后段填满练习，训练三色路径让位和长度预算。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 3,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 3
      },
      {
        color: "yellow",
        role: "target",
        x: 2,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 1,
        y: 2,
        targetLength: 6
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 1
      }
    ],
    solution: {
      red: [
        [0, 3],
        [1, 3],
        [2, 3],
        [3, 3],
        [3, 2],
        [3, 1],
        [3, 0]
      ],
      yellow: [
        [2, 0],
        [2, 1],
        [2, 2]
      ],
      blue: [
        [1, 2],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0],
        [1, 1]
      ]
    }
  },
  {
    id: "level-012",
    order: 12,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "4x4 后段填满练习，训练三色路径让位和长度预算。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 3,
        targetLength: 5
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 0,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 0,
        y: 1,
        targetLength: 4
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 1
      }
    ],
    solution: {
      red: [
        [2, 3],
        [3, 3],
        [3, 2],
        [3, 1],
        [3, 0]
      ],
      yellow: [
        [2, 0],
        [2, 1],
        [2, 2],
        [1, 2],
        [1, 3],
        [0, 3],
        [0, 2]
      ],
      blue: [
        [0, 1],
        [0, 0],
        [1, 0],
        [1, 1]
      ]
    }
  },
  {
    id: "level-013",
    order: 13,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "4x4 后段填满练习，训练三色路径让位和长度预算。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 3,
        targetLength: 5
      },
      {
        color: "red",
        role: "target",
        x: 1,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 1,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 5
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 0
      }
    ],
    solution: {
      red: [
        [0, 3],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0]
      ],
      yellow: [
        [1, 1],
        [1, 2],
        [1, 3],
        [2, 3],
        [3, 3],
        [3, 2]
      ],
      blue: [
        [2, 2],
        [2, 1],
        [3, 1],
        [3, 0],
        [2, 0]
      ]
    }
  },
  {
    id: "level-014",
    order: 14,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "4x4 后段填满练习，训练三色路径让位和长度预算。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 1,
        y: 3,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 1,
        y: 2
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 4
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 4
      },
      {
        color: "blue",
        role: "target",
        x: 3,
        y: 0
      }
    ],
    solution: {
      red: [
        [1, 3],
        [0, 3],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0],
        [1, 1],
        [1, 2]
      ],
      yellow: [
        [2, 2],
        [2, 3],
        [3, 3],
        [3, 2]
      ],
      blue: [
        [3, 1],
        [2, 1],
        [2, 0],
        [3, 0]
      ]
    }
  },
  {
    id: "level-015",
    order: 15,
    width: 4,
    height: 4,
    fillRequired: true,
    teachingGoal: "4x4 后段填满练习，训练三色路径让位和长度预算。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 1,
        y: 1
      },
      {
        color: "yellow",
        role: "origin",
        x: 0,
        y: 1,
        targetLength: 3
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 4
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 1
      }
    ],
    solution: {
      red: [
        [2, 2],
        [3, 2],
        [3, 3],
        [2, 3],
        [1, 3],
        [0, 3],
        [0, 2],
        [1, 2],
        [1, 1]
      ],
      yellow: [
        [0, 1],
        [0, 0],
        [1, 0]
      ],
      blue: [
        [2, 0],
        [3, 0],
        [3, 1],
        [2, 1]
      ]
    }
  },
  {
    id: "level-016",
    order: 16,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 4,
        y: 1
      },
      {
        color: "yellow",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 4
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 3,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 3
      },
      {
        color: "green",
        role: "origin",
        x: 1,
        y: 2,
        targetLength: 6
      },
      {
        color: "green",
        role: "target",
        x: 0,
        y: 0
      }
    ],
    solution: {
      red: [
        [2, 2],
        [2, 1],
        [2, 0],
        [3, 0],
        [4, 0],
        [4, 1]
      ],
      yellow: [
        [3, 1],
        [3, 2],
        [4, 2],
        [4, 3],
        [4, 4],
        [3, 4]
      ],
      blue: [
        [3, 3],
        [2, 3],
        [2, 4],
        [1, 4],
        [0, 4],
        [0, 3],
        [1, 3]
      ],
      green: [
        [1, 2],
        [0, 2],
        [0, 1],
        [1, 1],
        [1, 0],
        [0, 0]
      ]
    }
  },
  {
    id: "level-017",
    order: 17,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 1,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 1,
        targetLength: 8
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 4,
        y: 2,
        targetLength: 6
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 3
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 4,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 1,
        y: 3
      }
    ],
    solution: {
      red: [
        [2, 2],
        [1, 2],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0]
      ],
      yellow: [
        [1, 1],
        [2, 1],
        [2, 0],
        [3, 0],
        [4, 0],
        [4, 1],
        [3, 1],
        [3, 2]
      ],
      blue: [
        [4, 2],
        [4, 3],
        [4, 4],
        [3, 4],
        [3, 3],
        [2, 3]
      ],
      green: [
        [2, 4],
        [1, 4],
        [0, 4],
        [0, 3],
        [1, 3]
      ]
    }
  },
  {
    id: "level-018",
    order: 18,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 0,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 0,
        y: 2
      },
      {
        color: "yellow",
        role: "origin",
        x: 0,
        y: 3,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 1
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 5
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 3
      },
      {
        color: "green",
        role: "origin",
        x: 1,
        y: 2,
        targetLength: 4
      },
      {
        color: "green",
        role: "target",
        x: 2,
        y: 2
      }
    ],
    solution: {
      red: [
        [4, 0],
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [0, 2]
      ],
      yellow: [
        [0, 3],
        [0, 4],
        [1, 4],
        [2, 4],
        [3, 4],
        [4, 4],
        [4, 3],
        [4, 2],
        [4, 1]
      ],
      blue: [
        [3, 1],
        [3, 2],
        [3, 3],
        [2, 3],
        [1, 3]
      ],
      green: [
        [1, 2],
        [1, 1],
        [2, 1],
        [2, 2]
      ]
    }
  },
  {
    id: "level-019",
    order: 19,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 4,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 2,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 3,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 4,
        y: 2,
        targetLength: 3
      },
      {
        color: "blue",
        role: "target",
        x: 4,
        y: 0
      },
      {
        color: "green",
        role: "origin",
        x: 3,
        y: 0,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 1,
        y: 1
      }
    ],
    solution: {
      red: [
        [0, 4],
        [1, 4],
        [2, 4],
        [3, 4],
        [4, 4],
        [4, 3],
        [3, 3],
        [2, 3]
      ],
      yellow: [
        [1, 3],
        [0, 3],
        [0, 2],
        [1, 2],
        [2, 2],
        [3, 2]
      ],
      blue: [
        [4, 2],
        [4, 1],
        [4, 0]
      ],
      green: [
        [3, 0],
        [3, 1],
        [2, 1],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [1, 1]
      ]
    }
  },
  {
    id: "level-020",
    order: 20,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 2,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 0,
        y: 2
      },
      {
        color: "yellow",
        role: "origin",
        x: 0,
        y: 3,
        targetLength: 5
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 1,
        y: 1,
        targetLength: 6
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 3
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 4,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 4,
        y: 4
      }
    ],
    solution: {
      red: [
        [4, 2],
        [4, 1],
        [4, 0],
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [0, 2]
      ],
      yellow: [
        [0, 3],
        [0, 4],
        [1, 4],
        [1, 3],
        [1, 2]
      ],
      blue: [
        [1, 1],
        [2, 1],
        [3, 1],
        [3, 2],
        [2, 2],
        [2, 3]
      ],
      green: [
        [2, 4],
        [3, 4],
        [3, 3],
        [4, 3],
        [4, 4]
      ]
    }
  },
  {
    id: "level-021",
    order: 21,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 0,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 4,
        y: 2
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 3,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 0,
        y: 4
      },
      {
        color: "blue",
        role: "origin",
        x: 0,
        y: 3,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 1,
        y: 1
      }
    ],
    solution: {
      red: [
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0],
        [4, 0],
        [4, 1],
        [4, 2]
      ],
      yellow: [
        [4, 3],
        [4, 4],
        [3, 4],
        [2, 4],
        [1, 4],
        [0, 4]
      ],
      blue: [
        [0, 3],
        [1, 3],
        [2, 3],
        [3, 3],
        [3, 2],
        [3, 1],
        [2, 1]
      ],
      green: [
        [2, 2],
        [1, 2],
        [0, 2],
        [0, 1],
        [1, 1]
      ]
    }
  },
  {
    id: "level-022",
    order: 22,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 4,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 3,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 6
      },
      {
        color: "blue",
        role: "target",
        x: 3,
        y: 2
      },
      {
        color: "green",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 2,
        y: 2
      }
    ],
    solution: {
      red: [
        [0, 4],
        [1, 4],
        [2, 4],
        [3, 4],
        [4, 4],
        [4, 3],
        [3, 3]
      ],
      yellow: [
        [2, 3],
        [1, 3],
        [0, 3],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0]
      ],
      blue: [
        [2, 0],
        [3, 0],
        [4, 0],
        [4, 1],
        [4, 2],
        [3, 2]
      ],
      green: [
        [3, 1],
        [2, 1],
        [1, 1],
        [1, 2],
        [2, 2]
      ]
    }
  },
  {
    id: "level-023",
    order: 23,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 3,
        y: 3,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 0,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 0,
        y: 4,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 1,
        targetLength: 4
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 1
      }
    ],
    solution: {
      red: [
        [3, 3],
        [3, 4],
        [4, 4],
        [4, 3],
        [4, 2],
        [4, 1],
        [4, 0],
        [3, 0]
      ],
      yellow: [
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [0, 2],
        [0, 3]
      ],
      blue: [
        [0, 4],
        [1, 4],
        [2, 4],
        [2, 3],
        [1, 3],
        [1, 2],
        [1, 1]
      ],
      green: [
        [2, 1],
        [2, 2],
        [3, 2],
        [3, 1]
      ]
    }
  },
  {
    id: "level-024",
    order: 24,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 4,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 0,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 4,
        y: 3,
        targetLength: 5
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 1,
        y: 1,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 2,
        y: 2
      }
    ],
    solution: {
      red: [
        [4, 4],
        [3, 4],
        [2, 4],
        [1, 4],
        [0, 4],
        [0, 3]
      ],
      yellow: [
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0],
        [4, 0],
        [4, 1],
        [4, 2]
      ],
      blue: [
        [4, 3],
        [3, 3],
        [3, 2],
        [3, 1],
        [2, 1]
      ],
      green: [
        [1, 1],
        [1, 2],
        [1, 3],
        [2, 3],
        [2, 2]
      ]
    }
  },
  {
    id: "level-025",
    order: 25,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 4,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 0,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 4
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 1,
        y: 1,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 2
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 1,
        targetLength: 6
      },
      {
        color: "green",
        role: "target",
        x: 4,
        y: 0
      }
    ],
    solution: {
      red: [
        [4, 4],
        [3, 4],
        [2, 4],
        [1, 4],
        [0, 4],
        [0, 3]
      ],
      yellow: [
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0]
      ],
      blue: [
        [1, 1],
        [1, 2],
        [1, 3],
        [2, 3],
        [3, 3],
        [4, 3],
        [4, 2],
        [3, 2],
        [2, 2]
      ],
      green: [
        [2, 1],
        [2, 0],
        [3, 0],
        [3, 1],
        [4, 1],
        [4, 0]
      ]
    }
  },
  {
    id: "level-026",
    order: 26,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 4,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 0,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 2,
        y: 3,
        targetLength: 4
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 0
      },
      {
        color: "green",
        role: "origin",
        x: 3,
        y: 0,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 3
      }
    ],
    solution: {
      red: [
        [4, 4],
        [3, 4],
        [2, 4],
        [1, 4],
        [0, 4],
        [0, 3]
      ],
      yellow: [
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0],
        [1, 1],
        [1, 2],
        [1, 3]
      ],
      blue: [
        [2, 3],
        [2, 2],
        [2, 1],
        [2, 0]
      ],
      green: [
        [3, 0],
        [4, 0],
        [4, 1],
        [3, 1],
        [3, 2],
        [4, 2],
        [4, 3],
        [3, 3]
      ]
    }
  },
  {
    id: "level-027",
    order: 27,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 1,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 3,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 3,
        targetLength: 6
      },
      {
        color: "blue",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "green",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 7
      },
      {
        color: "green",
        role: "target",
        x: 0,
        y: 0
      }
    ],
    solution: {
      red: [
        [2, 2],
        [1, 2],
        [0, 2],
        [0, 3],
        [0, 4],
        [1, 4]
      ],
      yellow: [
        [1, 3],
        [2, 3],
        [2, 4],
        [3, 4],
        [4, 4],
        [4, 3]
      ],
      blue: [
        [3, 3],
        [3, 2],
        [4, 2],
        [4, 1],
        [4, 0],
        [3, 0]
      ],
      green: [
        [3, 1],
        [2, 1],
        [2, 0],
        [1, 0],
        [1, 1],
        [0, 1],
        [0, 0]
      ]
    }
  },
  {
    id: "level-028",
    order: 28,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 5
      },
      {
        color: "red",
        role: "target",
        x: 4,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 3,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 0,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 0,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 1,
        y: 1,
        targetLength: 7
      },
      {
        color: "green",
        role: "target",
        x: 0,
        y: 4
      }
    ],
    solution: {
      red: [
        [2, 2],
        [2, 3],
        [2, 4],
        [3, 4],
        [4, 4]
      ],
      yellow: [
        [4, 3],
        [3, 3],
        [3, 2],
        [4, 2],
        [4, 1],
        [4, 0]
      ],
      blue: [
        [3, 0],
        [3, 1],
        [2, 1],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1]
      ],
      green: [
        [1, 1],
        [1, 2],
        [0, 2],
        [0, 3],
        [1, 3],
        [1, 4],
        [0, 4]
      ]
    }
  },
  {
    id: "level-029",
    order: 29,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 5
      },
      {
        color: "red",
        role: "target",
        x: 2,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 3,
        y: 4,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 3,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 1,
        targetLength: 6
      },
      {
        color: "green",
        role: "target",
        x: 1,
        y: 1
      }
    ],
    solution: {
      red: [
        [0, 2],
        [0, 3],
        [0, 4],
        [1, 4],
        [2, 4]
      ],
      yellow: [
        [3, 4],
        [4, 4],
        [4, 3],
        [3, 3],
        [2, 3],
        [1, 3],
        [1, 2]
      ],
      blue: [
        [2, 2],
        [3, 2],
        [4, 2],
        [4, 1],
        [4, 0],
        [3, 0],
        [3, 1]
      ],
      green: [
        [2, 1],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [1, 1]
      ]
    }
  },
  {
    id: "level-030",
    order: 30,
    width: 5,
    height: 5,
    fillRequired: true,
    teachingGoal: "5x5 多路径填满练习，训练更大空间中的蛇形绕行。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 3,
        y: 3,
        targetLength: 5
      },
      {
        color: "red",
        role: "target",
        x: 2,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 4,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 2
      },
      {
        color: "blue",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 5
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 1,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 4,
        y: 2
      }
    ],
    solution: {
      red: [
        [3, 3],
        [4, 3],
        [4, 4],
        [3, 4],
        [2, 4]
      ],
      yellow: [
        [1, 4],
        [0, 4],
        [0, 3],
        [1, 3],
        [2, 3],
        [2, 2],
        [1, 2]
      ],
      blue: [
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0],
        [1, 1]
      ],
      green: [
        [2, 1],
        [2, 0],
        [3, 0],
        [4, 0],
        [4, 1],
        [3, 1],
        [3, 2],
        [4, 2]
      ]
    }
  },
  {
    id: "level-031",
    order: 31,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 5,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 4,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 1,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 0,
        y: 5
      },
      {
        color: "blue",
        role: "origin",
        x: 0,
        y: 4,
        targetLength: 6
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 0
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 7
      },
      {
        color: "green",
        role: "target",
        x: 2,
        y: 4
      },
      {
        color: "purple",
        role: "origin",
        x: 1,
        y: 4,
        targetLength: 6
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 1
      }
    ],
    solution: {
      red: [
        [4, 5],
        [5, 5],
        [5, 4],
        [5, 3],
        [5, 2],
        [5, 1],
        [5, 0],
        [4, 0]
      ],
      yellow: [
        [4, 1],
        [4, 2],
        [4, 3],
        [4, 4],
        [3, 4],
        [3, 5],
        [2, 5],
        [1, 5],
        [0, 5]
      ],
      blue: [
        [0, 4],
        [0, 3],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0]
      ],
      green: [
        [2, 0],
        [3, 0],
        [3, 1],
        [3, 2],
        [3, 3],
        [2, 3],
        [2, 4]
      ],
      purple: [
        [1, 4],
        [1, 3],
        [1, 2],
        [2, 2],
        [2, 1],
        [1, 1]
      ]
    }
  },
  {
    id: "level-032",
    order: 32,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 3,
        y: 2,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 4,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 2,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 0,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 1,
        y: 0,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 5,
        y: 4
      },
      {
        color: "green",
        role: "origin",
        x: 5,
        y: 5,
        targetLength: 4
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 4
      },
      {
        color: "purple",
        role: "origin",
        x: 3,
        y: 5,
        targetLength: 7
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 5
      }
    ],
    solution: {
      red: [
        [3, 2],
        [2, 2],
        [1, 2],
        [0, 2],
        [0, 3],
        [1, 3],
        [2, 3],
        [3, 3],
        [4, 3]
      ],
      yellow: [
        [4, 2],
        [4, 1],
        [3, 1],
        [2, 1],
        [1, 1],
        [0, 1],
        [0, 0]
      ],
      blue: [
        [1, 0],
        [2, 0],
        [3, 0],
        [4, 0],
        [5, 0],
        [5, 1],
        [5, 2],
        [5, 3],
        [5, 4]
      ],
      green: [
        [5, 5],
        [4, 5],
        [4, 4],
        [3, 4]
      ],
      purple: [
        [3, 5],
        [2, 5],
        [2, 4],
        [1, 4],
        [0, 4],
        [0, 5],
        [1, 5]
      ]
    }
  },
  {
    id: "level-033",
    order: 33,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 0,
        targetLength: 3
      },
      {
        color: "red",
        role: "target",
        x: 5,
        y: 1
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 1,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 3,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 4
      },
      {
        color: "green",
        role: "origin",
        x: 3,
        y: 4,
        targetLength: 9
      },
      {
        color: "green",
        role: "target",
        x: 0,
        y: 3
      },
      {
        color: "purple",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 6
      },
      {
        color: "purple",
        role: "target",
        x: 0,
        y: 1
      }
    ],
    solution: {
      red: [
        [4, 0],
        [5, 0],
        [5, 1]
      ],
      yellow: [
        [4, 1],
        [4, 2],
        [5, 2],
        [5, 3],
        [5, 4],
        [5, 5],
        [4, 5],
        [4, 4],
        [4, 3]
      ],
      blue: [
        [3, 3],
        [3, 2],
        [3, 1],
        [3, 0],
        [2, 0],
        [2, 1],
        [2, 2],
        [2, 3],
        [2, 4]
      ],
      green: [
        [3, 4],
        [3, 5],
        [2, 5],
        [1, 5],
        [0, 5],
        [0, 4],
        [1, 4],
        [1, 3],
        [0, 3]
      ],
      purple: [
        [0, 2],
        [1, 2],
        [1, 1],
        [1, 0],
        [0, 0],
        [0, 1]
      ]
    }
  },
  {
    id: "level-034",
    order: 34,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 2,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 2,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 3,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 0,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 0,
        y: 5
      },
      {
        color: "green",
        role: "origin",
        x: 1,
        y: 5,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 5
      },
      {
        color: "purple",
        role: "origin",
        x: 3,
        y: 4,
        targetLength: 5
      },
      {
        color: "purple",
        role: "target",
        x: 4,
        y: 5
      }
    ],
    solution: {
      red: [
        [4, 2],
        [5, 2],
        [5, 3],
        [4, 3],
        [3, 3],
        [3, 2],
        [2, 2],
        [2, 3]
      ],
      yellow: [
        [1, 3],
        [1, 2],
        [1, 1],
        [2, 1],
        [3, 1],
        [4, 1],
        [5, 1],
        [5, 0],
        [4, 0]
      ],
      blue: [
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [0, 2],
        [0, 3],
        [0, 4],
        [0, 5]
      ],
      green: [
        [1, 5],
        [1, 4],
        [2, 4],
        [2, 5],
        [3, 5]
      ],
      purple: [
        [3, 4],
        [4, 4],
        [5, 4],
        [5, 5],
        [4, 5]
      ]
    }
  },
  {
    id: "level-035",
    order: 35,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 1,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 2
      },
      {
        color: "yellow",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 4,
        y: 3,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 3,
        y: 4
      },
      {
        color: "green",
        role: "origin",
        x: 3,
        y: 5,
        targetLength: 9
      },
      {
        color: "green",
        role: "target",
        x: 1,
        y: 3
      },
      {
        color: "purple",
        role: "origin",
        x: 1,
        y: 2,
        targetLength: 6
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 1
      }
    ],
    solution: {
      red: [
        [4, 1],
        [4, 0],
        [5, 0],
        [5, 1],
        [5, 2],
        [4, 2],
        [3, 2]
      ],
      yellow: [
        [3, 1],
        [3, 0],
        [2, 0],
        [2, 1],
        [2, 2],
        [2, 3],
        [3, 3]
      ],
      blue: [
        [4, 3],
        [5, 3],
        [5, 4],
        [5, 5],
        [4, 5],
        [4, 4],
        [3, 4]
      ],
      green: [
        [3, 5],
        [2, 5],
        [2, 4],
        [1, 4],
        [1, 5],
        [0, 5],
        [0, 4],
        [0, 3],
        [1, 3]
      ],
      purple: [
        [1, 2],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0],
        [1, 1]
      ]
    }
  },
  {
    id: "level-036",
    order: 36,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 4,
        y: 5,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 5,
        y: 1
      },
      {
        color: "yellow",
        role: "origin",
        x: 5,
        y: 0,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 2,
        y: 5
      },
      {
        color: "blue",
        role: "origin",
        x: 1,
        y: 5,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 0,
        y: 0
      },
      {
        color: "green",
        role: "origin",
        x: 1,
        y: 0,
        targetLength: 7
      },
      {
        color: "green",
        role: "target",
        x: 1,
        y: 2
      },
      {
        color: "purple",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 5
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 3
      }
    ],
    solution: {
      red: [
        [4, 5],
        [5, 5],
        [5, 4],
        [4, 4],
        [4, 3],
        [5, 3],
        [5, 2],
        [5, 1]
      ],
      yellow: [
        [5, 0],
        [4, 0],
        [4, 1],
        [4, 2],
        [3, 2],
        [3, 3],
        [3, 4],
        [3, 5],
        [2, 5]
      ],
      blue: [
        [1, 5],
        [0, 5],
        [0, 4],
        [0, 3],
        [0, 2],
        [0, 1],
        [0, 0]
      ],
      green: [
        [1, 0],
        [2, 0],
        [3, 0],
        [3, 1],
        [2, 1],
        [1, 1],
        [1, 2]
      ],
      purple: [
        [2, 2],
        [2, 3],
        [2, 4],
        [1, 4],
        [1, 3]
      ]
    }
  },
  {
    id: "level-037",
    order: 37,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 3,
        y: 2,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 4,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 1,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 0,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 0,
        y: 4,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 1,
        targetLength: 7
      },
      {
        color: "green",
        role: "target",
        x: 4,
        y: 5
      },
      {
        color: "purple",
        role: "origin",
        x: 5,
        y: 5,
        targetLength: 7
      },
      {
        color: "purple",
        role: "target",
        x: 3,
        y: 3
      }
    ],
    solution: {
      red: [
        [3, 2],
        [4, 2],
        [5, 2],
        [5, 1],
        [5, 0],
        [4, 0]
      ],
      yellow: [
        [4, 1],
        [3, 1],
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [0, 2],
        [0, 3]
      ],
      blue: [
        [0, 4],
        [0, 5],
        [1, 5],
        [1, 4],
        [1, 3],
        [1, 2],
        [1, 1]
      ],
      green: [
        [2, 1],
        [2, 2],
        [2, 3],
        [2, 4],
        [2, 5],
        [3, 5],
        [4, 5]
      ],
      purple: [
        [5, 5],
        [5, 4],
        [5, 3],
        [4, 3],
        [4, 4],
        [3, 4],
        [3, 3]
      ]
    }
  },
  {
    id: "level-038",
    order: 38,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 5,
        y: 0,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 1,
        y: 1
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 1,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 5,
        y: 4
      },
      {
        color: "blue",
        role: "origin",
        x: 5,
        y: 5,
        targetLength: 8
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 4
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 4,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 4,
        y: 2
      },
      {
        color: "purple",
        role: "origin",
        x: 3,
        y: 2,
        targetLength: 8
      },
      {
        color: "purple",
        role: "target",
        x: 0,
        y: 2
      }
    ],
    solution: {
      red: [
        [5, 0],
        [4, 0],
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [1, 1]
      ],
      yellow: [
        [2, 1],
        [3, 1],
        [4, 1],
        [5, 1],
        [5, 2],
        [5, 3],
        [5, 4]
      ],
      blue: [
        [5, 5],
        [4, 5],
        [3, 5],
        [2, 5],
        [1, 5],
        [0, 5],
        [0, 4],
        [1, 4]
      ],
      green: [
        [2, 4],
        [3, 4],
        [4, 4],
        [4, 3],
        [4, 2]
      ],
      purple: [
        [3, 2],
        [3, 3],
        [2, 3],
        [2, 2],
        [1, 2],
        [1, 3],
        [0, 3],
        [0, 2]
      ]
    }
  },
  {
    id: "level-039",
    order: 39,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 5,
        y: 4,
        targetLength: 8
      },
      {
        color: "red",
        role: "target",
        x: 0,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 4,
        targetLength: 6
      },
      {
        color: "yellow",
        role: "target",
        x: 5,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 5,
        y: 2,
        targetLength: 5
      },
      {
        color: "blue",
        role: "target",
        x: 2,
        y: 3
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "purple",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 9
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 3
      }
    ],
    solution: {
      red: [
        [5, 4],
        [5, 5],
        [4, 5],
        [3, 5],
        [2, 5],
        [1, 5],
        [0, 5],
        [0, 4]
      ],
      yellow: [
        [1, 4],
        [2, 4],
        [3, 4],
        [4, 4],
        [4, 3],
        [5, 3]
      ],
      blue: [
        [5, 2],
        [4, 2],
        [3, 2],
        [3, 3],
        [2, 3]
      ],
      green: [
        [2, 2],
        [2, 1],
        [3, 1],
        [4, 1],
        [5, 1],
        [5, 0],
        [4, 0],
        [3, 0]
      ],
      purple: [
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [1, 1],
        [1, 2],
        [0, 2],
        [0, 3],
        [1, 3]
      ]
    }
  },
  {
    id: "level-040",
    order: 40,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 1,
        targetLength: 5
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 0,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 4
      },
      {
        color: "blue",
        role: "origin",
        x: 4,
        y: 3,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 2
      },
      {
        color: "green",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 7
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 5
      },
      {
        color: "purple",
        role: "origin",
        x: 3,
        y: 4,
        targetLength: 8
      },
      {
        color: "purple",
        role: "target",
        x: 2,
        y: 2
      }
    ],
    solution: {
      red: [
        [0, 1],
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0]
      ],
      yellow: [
        [4, 0],
        [5, 0],
        [5, 1],
        [5, 2],
        [5, 3],
        [5, 4],
        [5, 5],
        [4, 5],
        [4, 4]
      ],
      blue: [
        [4, 3],
        [4, 2],
        [4, 1],
        [3, 1],
        [2, 1],
        [1, 1],
        [1, 2]
      ],
      green: [
        [0, 2],
        [0, 3],
        [0, 4],
        [0, 5],
        [1, 5],
        [2, 5],
        [3, 5]
      ],
      purple: [
        [3, 4],
        [2, 4],
        [1, 4],
        [1, 3],
        [2, 3],
        [3, 3],
        [3, 2],
        [2, 2]
      ]
    }
  },
  {
    id: "level-041",
    order: 41,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 1,
        y: 0,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 2,
        y: 3
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 4
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 5,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 5,
        y: 2,
        targetLength: 9
      },
      {
        color: "green",
        role: "target",
        x: 2,
        y: 5
      },
      {
        color: "purple",
        role: "origin",
        x: 2,
        y: 4,
        targetLength: 5
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 5
      }
    ],
    solution: {
      red: [
        [1, 0],
        [0, 0],
        [0, 1],
        [1, 1],
        [1, 2],
        [0, 2],
        [0, 3],
        [1, 3],
        [2, 3]
      ],
      yellow: [
        [2, 2],
        [2, 1],
        [2, 0],
        [3, 0]
      ],
      blue: [
        [3, 1],
        [3, 2],
        [3, 3],
        [4, 3],
        [4, 2],
        [4, 1],
        [4, 0],
        [5, 0],
        [5, 1]
      ],
      green: [
        [5, 2],
        [5, 3],
        [5, 4],
        [5, 5],
        [4, 5],
        [4, 4],
        [3, 4],
        [3, 5],
        [2, 5]
      ],
      purple: [
        [2, 4],
        [1, 4],
        [0, 4],
        [0, 5],
        [1, 5]
      ]
    }
  },
  {
    id: "level-042",
    order: 42,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 5
      },
      {
        color: "red",
        role: "target",
        x: 5,
        y: 1
      },
      {
        color: "yellow",
        role: "origin",
        x: 5,
        y: 0,
        targetLength: 9
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 0,
        y: 0,
        targetLength: 7
      },
      {
        color: "blue",
        role: "target",
        x: 0,
        y: 4
      },
      {
        color: "green",
        role: "origin",
        x: 0,
        y: 5,
        targetLength: 7
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 4
      },
      {
        color: "purple",
        role: "origin",
        x: 4,
        y: 4,
        targetLength: 8
      },
      {
        color: "purple",
        role: "target",
        x: 2,
        y: 5
      }
    ],
    solution: {
      red: [
        [2, 2],
        [3, 2],
        [4, 2],
        [5, 2],
        [5, 1]
      ],
      yellow: [
        [5, 0],
        [4, 0],
        [4, 1],
        [3, 1],
        [3, 0],
        [2, 0],
        [2, 1],
        [1, 1],
        [1, 0]
      ],
      blue: [
        [0, 0],
        [0, 1],
        [0, 2],
        [1, 2],
        [1, 3],
        [0, 3],
        [0, 4]
      ],
      green: [
        [0, 5],
        [1, 5],
        [1, 4],
        [2, 4],
        [2, 3],
        [3, 3],
        [3, 4]
      ],
      purple: [
        [4, 4],
        [4, 3],
        [5, 3],
        [5, 4],
        [5, 5],
        [4, 5],
        [3, 5],
        [2, 5]
      ]
    }
  },
  {
    id: "level-043",
    order: 43,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 1,
        y: 5,
        targetLength: 6
      },
      {
        color: "red",
        role: "target",
        x: 2,
        y: 5
      },
      {
        color: "yellow",
        role: "origin",
        x: 3,
        y: 5,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 5,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 5,
        y: 2,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 0,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 0,
        y: 2,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 4,
        y: 1
      },
      {
        color: "purple",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 6
      },
      {
        color: "purple",
        role: "target",
        x: 2,
        y: 1
      }
    ],
    solution: {
      red: [
        [1, 5],
        [0, 5],
        [0, 4],
        [1, 4],
        [2, 4],
        [2, 5]
      ],
      yellow: [
        [3, 5],
        [3, 4],
        [4, 4],
        [4, 5],
        [5, 5],
        [5, 4],
        [5, 3]
      ],
      blue: [
        [5, 2],
        [5, 1],
        [5, 0],
        [4, 0],
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1]
      ],
      green: [
        [0, 2],
        [0, 3],
        [1, 3],
        [2, 3],
        [3, 3],
        [4, 3],
        [4, 2],
        [4, 1]
      ],
      purple: [
        [3, 1],
        [3, 2],
        [2, 2],
        [1, 2],
        [1, 1],
        [2, 1]
      ]
    }
  },
  {
    id: "level-044",
    order: 44,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 1,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 5,
        y: 2
      },
      {
        color: "yellow",
        role: "origin",
        x: 5,
        y: 3,
        targetLength: 8
      },
      {
        color: "yellow",
        role: "target",
        x: 4,
        y: 1
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 1,
        targetLength: 5
      },
      {
        color: "blue",
        role: "target",
        x: 3,
        y: 5
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 5,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 0,
        y: 2
      },
      {
        color: "purple",
        role: "origin",
        x: 0,
        y: 3,
        targetLength: 6
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 5
      }
    ],
    solution: {
      red: [
        [0, 1],
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0],
        [4, 0],
        [5, 0],
        [5, 1],
        [5, 2]
      ],
      yellow: [
        [5, 3],
        [5, 4],
        [5, 5],
        [4, 5],
        [4, 4],
        [4, 3],
        [4, 2],
        [4, 1]
      ],
      blue: [
        [3, 1],
        [3, 2],
        [3, 3],
        [3, 4],
        [3, 5]
      ],
      green: [
        [2, 5],
        [2, 4],
        [2, 3],
        [2, 2],
        [2, 1],
        [1, 1],
        [1, 2],
        [0, 2]
      ],
      purple: [
        [0, 3],
        [1, 3],
        [1, 4],
        [0, 4],
        [0, 5],
        [1, 5]
      ]
    }
  },
  {
    id: "level-045",
    order: 45,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 综合填满练习，训练五色长短线混合规划。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 1,
        y: 2,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 1,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 1,
        y: 3,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 4,
        y: 3,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 5,
        y: 0
      },
      {
        color: "green",
        role: "origin",
        x: 4,
        y: 0,
        targetLength: 5
      },
      {
        color: "green",
        role: "target",
        x: 0,
        y: 0
      },
      {
        color: "purple",
        role: "origin",
        x: 0,
        y: 1,
        targetLength: 8
      },
      {
        color: "purple",
        role: "target",
        x: 3,
        y: 1
      }
    ],
    solution: {
      red: [
        [1, 2],
        [0, 2],
        [0, 3],
        [0, 4],
        [0, 5],
        [1, 5],
        [1, 4]
      ],
      yellow: [
        [1, 3],
        [2, 3],
        [2, 4],
        [2, 5],
        [3, 5],
        [3, 4],
        [3, 3]
      ],
      blue: [
        [4, 3],
        [4, 4],
        [4, 5],
        [5, 5],
        [5, 4],
        [5, 3],
        [5, 2],
        [5, 1],
        [5, 0]
      ],
      green: [
        [4, 0],
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0]
      ],
      purple: [
        [0, 1],
        [1, 1],
        [2, 1],
        [2, 2],
        [3, 2],
        [4, 2],
        [4, 1],
        [3, 1]
      ]
    }
  },
  {
    id: "level-046",
    order: 46,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 压轴填满挑战，强调唯一解、移动端可读性和最后空格推理。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 0,
        y: 0,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 5
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 5,
        targetLength: 5
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 4
      },
      {
        color: "blue",
        role: "origin",
        x: 2,
        y: 4,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 5,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 5,
        y: 0,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 2,
        y: 2
      },
      {
        color: "purple",
        role: "origin",
        x: 2,
        y: 1,
        targetLength: 5
      },
      {
        color: "purple",
        role: "target",
        x: 3,
        y: 2
      }
    ],
    solution: {
      red: [
        [0, 0],
        [0, 1],
        [0, 2],
        [0, 3],
        [0, 4],
        [0, 5],
        [1, 5],
        [2, 5],
        [3, 5]
      ],
      yellow: [
        [4, 5],
        [5, 5],
        [5, 4],
        [4, 4],
        [3, 4]
      ],
      blue: [
        [2, 4],
        [1, 4],
        [1, 3],
        [2, 3],
        [3, 3],
        [4, 3],
        [5, 3],
        [5, 2],
        [5, 1]
      ],
      green: [
        [5, 0],
        [4, 0],
        [3, 0],
        [2, 0],
        [1, 0],
        [1, 1],
        [1, 2],
        [2, 2]
      ],
      purple: [
        [2, 1],
        [3, 1],
        [4, 1],
        [4, 2],
        [3, 2]
      ]
    }
  },
  {
    id: "level-047",
    order: 47,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 压轴填满挑战，强调唯一解、移动端可读性和最后空格推理。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 1,
        y: 3,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 5
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 5,
        targetLength: 5
      },
      {
        color: "yellow",
        role: "target",
        x: 3,
        y: 4
      },
      {
        color: "blue",
        role: "origin",
        x: 3,
        y: 3,
        targetLength: 6
      },
      {
        color: "blue",
        role: "target",
        x: 0,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 0,
        y: 0,
        targetLength: 8
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 2
      },
      {
        color: "purple",
        role: "origin",
        x: 4,
        y: 2,
        targetLength: 8
      },
      {
        color: "purple",
        role: "target",
        x: 5,
        y: 0
      }
    ],
    solution: {
      red: [
        [1, 3],
        [0, 3],
        [0, 4],
        [0, 5],
        [1, 5],
        [1, 4],
        [2, 4],
        [2, 5],
        [3, 5]
      ],
      yellow: [
        [4, 5],
        [5, 5],
        [5, 4],
        [4, 4],
        [3, 4]
      ],
      blue: [
        [3, 3],
        [2, 3],
        [2, 2],
        [1, 2],
        [0, 2],
        [0, 1]
      ],
      green: [
        [0, 0],
        [1, 0],
        [1, 1],
        [2, 1],
        [2, 0],
        [3, 0],
        [3, 1],
        [3, 2]
      ],
      purple: [
        [4, 2],
        [4, 3],
        [5, 3],
        [5, 2],
        [5, 1],
        [4, 1],
        [4, 0],
        [5, 0]
      ]
    }
  },
  {
    id: "level-048",
    order: 48,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 压轴填满挑战，强调唯一解、移动端可读性和最后空格推理。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 3,
        y: 5,
        targetLength: 9
      },
      {
        color: "red",
        role: "target",
        x: 4,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 4,
        y: 5,
        targetLength: 7
      },
      {
        color: "yellow",
        role: "target",
        x: 5,
        y: 0
      },
      {
        color: "blue",
        role: "origin",
        x: 4,
        y: 0,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 3,
        y: 1
      },
      {
        color: "green",
        role: "origin",
        x: 4,
        y: 1,
        targetLength: 4
      },
      {
        color: "green",
        role: "target",
        x: 3,
        y: 3
      },
      {
        color: "purple",
        role: "origin",
        x: 3,
        y: 2,
        targetLength: 7
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 2
      }
    ],
    solution: {
      red: [
        [3, 5],
        [2, 5],
        [1, 5],
        [0, 5],
        [0, 4],
        [1, 4],
        [2, 4],
        [3, 4],
        [4, 4]
      ],
      yellow: [
        [4, 5],
        [5, 5],
        [5, 4],
        [5, 3],
        [5, 2],
        [5, 1],
        [5, 0]
      ],
      blue: [
        [4, 0],
        [3, 0],
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [1, 1],
        [2, 1],
        [3, 1]
      ],
      green: [
        [4, 1],
        [4, 2],
        [4, 3],
        [3, 3]
      ],
      purple: [
        [3, 2],
        [2, 2],
        [2, 3],
        [1, 3],
        [0, 3],
        [0, 2],
        [1, 2]
      ]
    }
  },
  {
    id: "level-049",
    order: 49,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 压轴填满挑战，强调唯一解、移动端可读性和最后空格推理。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 2,
        y: 3,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 3,
        y: 0
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 0,
        targetLength: 5
      },
      {
        color: "yellow",
        role: "target",
        x: 1,
        y: 1
      },
      {
        color: "blue",
        role: "origin",
        x: 1,
        y: 2,
        targetLength: 8
      },
      {
        color: "blue",
        role: "target",
        x: 1,
        y: 5
      },
      {
        color: "green",
        role: "origin",
        x: 2,
        y: 5,
        targetLength: 9
      },
      {
        color: "green",
        role: "target",
        x: 4,
        y: 3
      },
      {
        color: "purple",
        role: "origin",
        x: 5,
        y: 3,
        targetLength: 7
      },
      {
        color: "purple",
        role: "target",
        x: 4,
        y: 0
      }
    ],
    solution: {
      red: [
        [2, 3],
        [3, 3],
        [3, 2],
        [2, 2],
        [2, 1],
        [3, 1],
        [3, 0]
      ],
      yellow: [
        [2, 0],
        [1, 0],
        [0, 0],
        [0, 1],
        [1, 1]
      ],
      blue: [
        [1, 2],
        [0, 2],
        [0, 3],
        [1, 3],
        [1, 4],
        [0, 4],
        [0, 5],
        [1, 5]
      ],
      green: [
        [2, 5],
        [2, 4],
        [3, 4],
        [3, 5],
        [4, 5],
        [5, 5],
        [5, 4],
        [4, 4],
        [4, 3]
      ],
      purple: [
        [5, 3],
        [5, 2],
        [4, 2],
        [4, 1],
        [5, 1],
        [5, 0],
        [4, 0]
      ]
    }
  },
  {
    id: "level-050",
    order: 50,
    width: 6,
    height: 6,
    fillRequired: true,
    teachingGoal: "6x6 压轴填满挑战，强调唯一解、移动端可读性和最后空格推理。",
    nodes: [
      {
        color: "red",
        role: "origin",
        x: 1,
        y: 3,
        targetLength: 7
      },
      {
        color: "red",
        role: "target",
        x: 2,
        y: 4
      },
      {
        color: "yellow",
        role: "origin",
        x: 2,
        y: 5,
        targetLength: 5
      },
      {
        color: "yellow",
        role: "target",
        x: 2,
        y: 3
      },
      {
        color: "blue",
        role: "origin",
        x: 2,
        y: 2,
        targetLength: 9
      },
      {
        color: "blue",
        role: "target",
        x: 5,
        y: 3
      },
      {
        color: "green",
        role: "origin",
        x: 5,
        y: 2,
        targetLength: 9
      },
      {
        color: "green",
        role: "target",
        x: 2,
        y: 1
      },
      {
        color: "purple",
        role: "origin",
        x: 1,
        y: 1,
        targetLength: 6
      },
      {
        color: "purple",
        role: "target",
        x: 1,
        y: 0
      }
    ],
    solution: {
      red: [
        [1, 3],
        [0, 3],
        [0, 4],
        [0, 5],
        [1, 5],
        [1, 4],
        [2, 4]
      ],
      yellow: [
        [2, 5],
        [3, 5],
        [3, 4],
        [3, 3],
        [2, 3]
      ],
      blue: [
        [2, 2],
        [3, 2],
        [4, 2],
        [4, 3],
        [4, 4],
        [4, 5],
        [5, 5],
        [5, 4],
        [5, 3]
      ],
      green: [
        [5, 2],
        [5, 1],
        [5, 0],
        [4, 0],
        [4, 1],
        [3, 1],
        [3, 0],
        [2, 0],
        [2, 1]
      ],
      purple: [
        [1, 1],
        [1, 2],
        [0, 2],
        [0, 1],
        [0, 0],
        [1, 0]
      ]
    }
  }
] as const satisfies readonly LevelJson[];
